<p>
  ship-password works!
</p>
